import { Grid, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import { Draggable, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd'
import Order from './Order'
import { SearchDocumentRequest, SearchDocumentResponse } from '../../../services/um/useSettingDocument'

const getItemStyle = (
    isDragging: boolean,
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined,
): React.CSSProperties => ({
    userSelect: 'none',
    padding: '24px',
    margin: '0 0 16px 0',

    // dragging
    backgroundColor: '#fff',
    border: isDragging ? '1px solid #db5f8e' : '1px solid #bdbdbd',
    borderRadius: '4px',

    ...draggableStyle,
})

type FiledDraggableProps = {
    dataList: SearchDocumentResponse[]
    isDragDisabled: boolean
    reLoadData?: (param: SearchDocumentRequest) => void
}

const FiledDraggable = ({ dataList, isDragDisabled, reLoadData }: FiledDraggableProps) => {
    const translate = useTranslate()
    const classes = useStyles()

    return (
        <Grid container>
            {dataList.length > 0 &&
                dataList.map((item: SearchDocumentResponse, index: number) => {
                    return (
                        <Grid item xs={12} key={item.documentID}>
                            <Draggable
                                key={item.documentID}
                                draggableId={`${item.documentID}`}
                                index={index}
                                isDragDisabled={isDragDisabled}
                            >
                                {(provided, snapshot): JSX.Element => (
                                    <div
                                        className={classes.root}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                    >
                                        <Order
                                            index={index}
                                            documentID={item.documentID}
                                            nameTH={item.name['th']}
                                            nameEN={item.name['en']}
                                            shortNameTH={item.shortName['th']}
                                            shortNameEN={item.shortName['en']}
                                            code={item.code}
                                            order={item.order}
                                            docRequire={item.documentRequire}
                                            reLoadData={reLoadData}
                                        />
                                    </div>
                                )}
                            </Draggable>
                        </Grid>
                    )
                })}
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100% !important',
        '&:hover': { border: '1px solid #db5f8e !important' },
    },
}))

export default FiledDraggable
